module.exports = __webpack_public_path__ + "img/4-3.b84e1026.png";